import {React , useState} from "react";
import { CiSearch } from "react-icons/ci";

const StudentsSubmissions = ({ archiveData }) => {
    const [Search, setSearch] = useState("")
  return (
    <div>
      <div className="Header">
        <h1>Students Submissions :</h1>
        <form action="search-container" className="search-container">
          <CiSearch className="icon" />
          <input type="text" id="search-bar" placeholder="Search Community" onChange={(e)=>setSearch(e.target.value)}/>
        </form>
      </div>

      <div className="table-container Scrollable-table">
        <table className="archive-table ">
          <thead>
            <tr>
              <th>Participant</th>
              <th>1st Week</th>
              <th>2nd Week</th>
              <th>3rd Week</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {archiveData.filter((el)=>el.Name.toLowerCase().includes(Search.toLowerCase())).map((item, index) => (
              <tr key={index}>
                <td>
                  <a href={item.Profile}>{item.Name}</a>
                </td>
                <td>
                  <a href="">Download</a>
                </td>
                <td>
                  <a href="">Download</a>
                </td>
                <td>
                  <a href="">Download</a>
                </td>
                <td>
                  <div className="Correction-Status">
                    <div className={item.CorrectionStatus[0]==="1"? "span Green":"span"}></div> 
                    <div className={item.CorrectionStatus[1]==="1"? "span Green":"span"}></div>
                    <div className={item.CorrectionStatus[2]==="1"? "span Green":"span"}></div>
                  </div>
                </td>
                <td>
                  <button>Assign Score</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default StudentsSubmissions;
